<!-- eslint-disable vue/attribute-hyphenation -->
<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<v-btn
									color="red"
									class="px-0"
									height="auto"
									exact
									x-large
									text
									:to="{name: 'agent'}"
								>
									ตัวแทนขาย
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span
									v-if="agent && agent.fired"
									class="red--text"
									style="overflow: hidden; text-overflow: ellipsis;"
								>
									เพิกถอนสิทธิ์การเป็นตัวแทน
								</span>
								<span
									v-else-if="agent"
									style="overflow: hidden; text-overflow: ellipsis;"
								>
									ตัวแทนรหัส {{ agent.id }}
								</span>
								<span v-else>
									ไม่พบตัวแทน
								</span>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

		<div
			class="bg-light-grey"
			style="position: relative;"
		>
			<v-overlay
				class="px-4"
				color="#ffffff"
				opacity="0.65"
				z-index="4"
				absolute
				:value="agent && (!agent.active || !agent.online || agent.fired)"
			>
				<div
					class="pa-3"
					style="background: rgba(255,255,255,0.55);"
				>
					<hr
						class="red--text"
						style="border-style: dashed;"
					>
					<div
						v-if="agent && agent.fired"
						class="black--text"
						style="max-width: 1000px;"
					>
						<h3 class="red--text my-2">
							ประกาศแจ้งข้อมูล
						</h3>
						<p>ขอเรียนแจ้งให้ทราบว่า บุคคลดังกล่าวได้พ้นสภาพการเป็นตัวแทนของบริษัทฯ เป็นที่เรียบร้อยแล้ว และไม่มีสิทธิ์ดำเนินงานหรือให้บริการในนามบริษัทฯ อีกต่อไป</p>
						<p>ทั้งนี้ หากท่านยังพบข้อมูลของบุคคลดังกล่าวบน Google หรือผลการค้นหาออนไลน์ ข้อมูลดังกล่าวอาจยังอยู่ในระหว่างการอัปเดตของระบบค้นหา ซึ่งบริษัทฯ ได้ดำเนินการปรับปรุงและยื่นคำขอให้อัปเดตข้อมูลแล้ว</p>
						<p>เพื่อความถูกต้องและปลอดภัย กรุณาติดต่อผ่านช่องทางอย่างเป็นทางการของบริษัทฯ หรือเลือกใช้บริการจากตัวแทนที่มีสถานะ “ปัจจุบัน” เท่านั้น</p>
						<p>ขออภัยในความไม่สะดวก และขอขอบพระคุณสำหรับความเข้าใจ</p>
					</div>
					<h1
						v-else
						class="red--text my-2 text-center"
					>
						สิ้นสุดการเป็นตัวแทนกับ บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด
					</h1>
					<hr
						class="red--text"
						style="border-style: dashed;"
					>
				</div>
			</v-overlay>

			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col xl="8">
						<v-row no-gutters>
							<v-col
								cols="12"
								md="3"
								style="min-width: 300px; max-width: 100%;"
								class="flex-grow-0 flex-shrink-0"
							>
								<z-img
									v-if="agent"
									:storage="agent.avatar_url || `https://api.tb.co.th/api/getImageAgent?id=${agent.avatar}`"
									class="agent-image"
									width="300"
									height="300"
								/>
								<v-skeleton-loader
									v-else
									tile
									type="image"
									width="300"
									height="300"
								/>
							</v-col>
							<v-col
								v-if="agent"
								cols="12"
								md="8"
								class="flex-grow-1 flex-shrink-0"
							>
								<v-row class="agent-detail px-10 py-4 py-md-0">
									<v-col
										cols="12"
										class="pb-0"
									>
										<v-icon
											color="red"
											large
										>
											mdi-account
										</v-icon>
										รหัสตัวแทน
										<b>{{ agent.id }}</b>
									</v-col>
									<template v-if="!agent.website_display_type || ['default', 'main'].includes(agent.website_display_type)">
										<v-col
											cols="12"
											md="7"
											class="pt-2 pb-0"
										>
											<b>{{ agentName }}</b>
											<div
												v-if="agent.active && !agent.fired"
												class="mt-1 d-flex"
											>
												<a
													:href="!agent.phone ? '#' : 'tel:' + agent.phone"
													:title="!agent.phone ? 'Agent ไม่มีเบอร์โทรศัพท์' : 'โทรหา Agent ที่เบอร์ ' + agent.phone"
													:onClick="`fbq('track', 'Tel.Agent.${agent.id}'); _lt('send', 'Tel.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
													class="d-flex align-center"
												>
													<v-icon
														color="red"
														class="mr-2"
													>
														mdi-phone
													</v-icon>
													{{ agent.phone }}
												</a>
												<a
													:href="!agent.line ? '#' : 'https://line.me/ti/p/~' + agent.line"
													:title="!agent.line ? 'Agent ไม่มี line' : 'ไลท์แชทกับ Agent ไอดี ' + agent.line"
													:onClick="`fbq('track', 'Line.Agent.${agent.id}'); _lt('send', 'Line.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
													target="_blank"
													class="d-flex align-center ml-6"
												>
													<img
														src="/images/2.0/icon/contact/line-red.png"
														alt="line"
														height="24"
														class="mr-2"
													>
													{{ agent.line || '-' }}
												</a>
											</div>
											<div
												v-else
												class="mt-1"
											>
												<br>
											</div>
										</v-col>
										<v-col
											cols="12"
											md="5"
											class="d-flex justify-center align-end pt-2 pb-0"
										>
											<template v-if="agent.active && !agent.fired">
												<v-btn
													v-if="agent.phone"
													color="#c20000"
													width="75"
													:href="'tel:' + agent.phone"
													:title="'โทรหา Agent ที่เบอร์ ' + agent.phone"
													:onClick="`fbq('track', 'Tel.Agent.${agent.id}'); _lt('send', 'Tel.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<v-icon color="#fff">
														mdi-phone
													</v-icon>
												</v-btn>
												<v-btn
													v-if="agent.line"
													color="#06c406"
													width="75"
													class="ml-2"
													:href="'https://line.me/ti/p/~' + agent.line"
													:title="'ไลท์แชทกับ Agent ไอดี ' + agent.line"
													:onClick="`fbq('track', 'Line.Agent.${agent.id}'); _lt('send', 'Line.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
													target="_blank"
												>
													<img
														src="/images/icon/line.png"
														alt="line"
														height="24"
													>
												</v-btn>
											</template>
										</v-col>
									</template>
									<v-col
										v-else
										cols="12"
										class="pt-3 pb-0 d-none d-md-block"
									>
										&nbsp;<br>&nbsp;
									</v-col>

									<template v-if="!agent.website_display_type || (agent.is_joint && ['default', 'joint'].includes(agent.website_display_type))">
										<v-col
											cols="12"
											md="7"
											class="pt-1 pb-2"
											:class="{'pt-2': !agent.phone_joint}"
										>
											<template v-if="agent.name_first_joint">
												<b>{{ agentJointName }}</b>
												<div class="mt-1 d-flex">
													<a
														:href="!agent.phone_joint ? '#' : 'tel:' + agent.phone_joint"
														:title="!agent.phone_joint ? 'Agent ไม่มีเบอร์โทรศัพท์' : 'โทรหา Agent ที่เบอร์ ' + agent.phone_joint"
														:onClick="`fbq('track', 'Tel.Agent.${agent.id}'); _lt('send', 'Tel.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
														class="d-flex align-center"
													>
														<v-icon
															color="red"
															class="mr-2"
														>
															mdi-phone
														</v-icon>
														{{ agent.phone_joint }}
													</a>
													<a
														:href="!agent.line_joint ? '#' : 'https://line.me/ti/p/~' + agent.line_joint"
														:title="!agent.line_joint ? 'Agent ไม่มี line' : 'ไลท์แชทกับ Agent ไอดี ' + agent.line_joint"
														:onClick="`fbq('track', 'Line.Agent.${agent.id}'); _lt('send', 'Line.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
														target="_blank"
														class="d-flex align-center ml-6"
													>
														<img
															src="/images/2.0/icon/contact/line-red.png"
															alt="line"
															height="24"
															class="mr-2"
														>
														{{ agent.line_joint || '-' }}
													</a>
												</div>
											</template>
											<template v-else>
												&nbsp;<br>&nbsp;
											</template>
										</v-col>
										<v-col
											cols="12"
											md="5"
											class="d-flex justify-center align-end pt-1 pb-2"
											:class="{'pt-2': !agent.phone_joint}"
										>
											<template v-if="agent.name_first_joint">
												<v-btn
													v-if="agent.phone_joint"
													color="#c20000"
													width="75"
													:href="'tel:' + agent.phone_joint"
													:title="'โทรหา Agent ที่เบอร์ ' + agent.phone_joint"
													:onClick="`fbq('track', 'Tel.Agent.${agent.id}'); _lt('send', 'Tel.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<v-icon color="#fff">
														mdi-phone
													</v-icon>
												</v-btn>
												<v-btn
													v-if="agent.line_joint"
													color="#06c406"
													width="75"
													class="ml-2"
													:href="'https://line.me/ti/p/~' + agent.line_joint"
													:title="'ไลท์แชทกับ Agent ไอดี ' + agent.line_joint"
													:onClick="`fbq('track', 'Line.Agent.${agent.id}'); _lt('send', 'Line.Agent.${agent.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
													target="_blank"
												>
													<img
														src="/images/icon/line.png"
														alt="line"
														height="24"
													>
												</v-btn>
											</template>
											<template v-else>
												&nbsp;<br>&nbsp;
											</template>
										</v-col>
									</template>
									<v-col
										v-else
										cols="12"
										class="pt-2 pb-2 d-none d-md-block"
									>
										&nbsp;<br>&nbsp;
									</v-col>

									<v-col
										cols="6"
										md="4"
										class="d-flex align-start"
									>
										<img
											src="/images/2.0/icon/review-gr.png"
											alt="line"
											height="45"
										>
										<div class="ml-2">
											<b>ผู้ใช้บริการ</b><br>
											<b v-if="!agent.active || agent.fired">-</b>
											<template v-else>
												<b class="red--text">
													{{ agent.total_customer || 0 }}
												</b> ราย
											</template>
										</div>
									</v-col>
									<v-col
										cols="6"
										md="4"
										class="d-flex align-start"
									>
										<img
											src="/images/2.0/icon/briefcase-gr.png"
											alt="line"
											height="45"
										>
										<div class="ml-2">
											<b>ประสบการณ์</b><br>
											<b v-if="!agent.active || agent.fired">-</b>
											<template v-else>
												<b class="red--text">
													{{ agent.experience || 1 }}
												</b> ปี
											</template>
										</div>
									</v-col>
									<v-col
										cols="12"
										md="4"
										class="d-flex align-start"
									>
										<img
											src="/images/2.0/icon/3star-gr.png"
											alt="line"
											height="45"
										>
										<div class="ml-2">
											<b>พื้นที่ให้บริการ</b>
											<div v-if="!agent.active || agent.fired">
												<b>-</b>
											</div>
											<div
												v-else
												style="white-space: nowrap;"
											>
												{{ agentLocation }}
											</div>
										</div>
									</v-col>
								</v-row>

								<div class="agent-share px-10 py-4 py-md-2">
									<v-btn
										:href="`https://www.facebook.com/sharer/sharer.php?u=https://tb.co.th${$route.path}`"
										:title="`แชร์ตัวแทน บนเฟสบุ๊ค`"
										target="_blank"
										small
										fab
									>
										<img
											src="/images/2.0/icon/facebook-bk.png"
											height="42"
										>
									</v-btn>
									<v-btn
										:href="`https://social-plugins.line.me/lineit/share?url=https://tb.co.th${$route.path}`"
										:title="`แชร์ตัวแทน ในไลน์`"
										target="_blank"
										class="ml-1"
										small
										fab
									>
										<img
											src="/images/2.0/icon/line-bk.png"
											height="42"
										>
									</v-btn>
									<v-btn
										title="คัดลอก URL"
										class="ml-1"
										height="40"
										small
										fab
										@click="copyText($refs.agentUrl)"
									>
										<img
											src="/images/2.0/icon/link-red.png"
											height="42"
										>
										<input
											ref="agentUrl"
											type="text"
											class="d-none"
											style="border: none !important;"
										>
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div
			v-if="agent && agent.active && !agent.fired && portfolioList && portfolioList.length > 0"
			class="bg-red-red"
		>
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2
							class="red--text my-7 pl-6 pl-md-0"
							style="position: relative;"
						>
							<img
								src="/images/2.0/icon/3star-bk.png"
								height="25"
								class="mr-2"
							>
							ผลงาน
						</h2>

						<portfolioCarousel
							v-if="agent"
							:display="3"
							:query="{ agent_id: agent.id }"
							page-control
							paging-center
							white
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div
			v-if="agent && agent.active && !agent.fired"
			class="pb-6"
		>
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						ref="topList"
						xl="8"
						class="mx-auto"
					>
						<v-row>
							<v-col
								cols="12"
								class="pt-6 pb-4 red--text"
							>
								<h2>
									<img
										src="/images/2.0/icon/property-bk.png"
										height="20"
										class="mr-2"
									>
									รายการสินทรัพย์
								</h2>
							</v-col>
							<v-col
								v-for="(propId, i) in propertyLoading ? parseInt(perPage) : propertyListByPage"
								:key="propId || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="propertyLoading" />
								<propertyListItem
									v-else
									:id="propId"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ propertyIds.length }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="Math.ceil(propertyIds.length / perPage)"
										:total-visible="10"
									/>
								</div>
								<div
									class="d-md-none text-center"
									style="white-space: nowrap;"
								>
									<span class="red--text">{{ propertyIds.length }}</span> รายการ
								</div>
							</v-col>
						</v-row>
						<!-- </v-col>
						</v-row> -->
					</v-col>
				</v-row>
			</v-container>
		</div>
		<v-snackbar
			v-model="snackbar"
			top
			right
			:timeout="6000"
		>
			{{ snackbarText }}
			<v-btn
				color="blue"
				text
				@click="snackbar = false"
			>
				Close
			</v-btn>
		</v-snackbar>
	</v-main>
</template>

<script>
const doc = 'agentDetail'

import { mapActions, mapGetters } from 'vuex'

import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'
import portfolioCarousel from '~/components/2.0/portfolio-carousel'

export default {
	// scrollToTop: true,
	name: 'AGENTDETAIL',
	layout: 'default_2',

	components: {
		propertyListItem,
		propertyListItemSkeleton,
		portfolioCarousel
	},

	async fetch(context) {
		let id = isNaN(context.params.id) ? context.params.id : parseInt(context.params.id)
		let agent = await context.store.dispatch('agent/getAgent', id)

		if (agent) {
			let desc = `Line ID: ${agent.line} (${agent.nick_name})`
			if (agent.line_joint) {
				desc += ` และ ${agent.line_joint} (${agent.nick_name_joint})`
			}
			desc += `, Email: ${agent.email}`

			if (!agent.active || agent.fired) {
				desc = 'สิ้นสุดการเป็นตัวแทนกับ บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด'
			}

			let title = `ข้อมูลตัวแทน ${agent.name} ${agent.surname} โทร ${!agent.active || agent.fired ? '-' : agent.phone} (${agent.nick_name})`
			if (agent.name_first_joint) {
				title += ` และ ${agent.name_first_joint} ${agent.name_last_joint} โทร ${!agent.active || agent.fired ? '-' : agent.phone_joint} (${agent.nick_name_joint})`
			}
			title += ` ตำแหน่ง ${agent.rank}`

			await context.store.dispatch('page/initial', {
				doc: doc,
				description: desc,
				fullPath: context.route.fullPath,
				image: agent.avatar_url || `https://api.tb.co.th/api/getImageAgent?id=${agent.avatar}`,
				title
			})
		} else {
			await context.store.dispatch('page/initial', {
				doc: doc,
				description: 'ไม่พบตัวแทน',
				fullPath: context.route.fullPath,
				title: 'ไม่พบตัวแทน',
			})
		}
	},

	data:() => ({
		snackbar: false,
		snackbarText: '',
		loading: true,
		propertyLoading: true,
		agent: null,
		propertyIds: [],
		propertyList: [],
		perPage: 12,
		page: 1,
		propSearchText: '',

		view_img: null,
		dialog: false,
		portfolioList: []
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
			location: 'location'
		}),

		agentName () {
			let text = (this.agent.name || '')
			text += ' ' + (this.agent.surname || '')
			if (this.agent.nick_name) {
				text += ` (${this.agent.nick_name})`
			}

			return text
		},

		agentJointName () {
			let text = (this.agent.name_first_joint || '')
			text += ' ' + (this.agent.name_last_joint || '')
			if (this.agent.nick_name_joint) {
				text += ` (${this.agent.nick_name_joint})`
			}

			return text
		},

		propertyListByPage () {
			let index = (this.page - 1) * this.perPage

			return this.propertyIds.slice(index, index + this.perPage)
		},

		agentLocation () {
			let text = ''
			let province = this.location.find(p => p.p === this.agent.work_area_province_id)
			if (province) {
				let district = province.v.find(d => d.d === this.agent.work_area_district_id)
				text += province.n
				text += district ? `, ${district.n}` : ''
			}

			return text
		},

		portfolioItemPerPage () {
			let col = 1
			if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				col = 3
			}
			if (this.$vuetify.breakpoint.sm) {
				col = 2
			}
			return col
		},
	},

	watch: {
		page () {
			this.$refs.topList.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},

		propSearchText (newVal) {
			if (newVal.trim() === '') {
				this.propertyIds = this.agent.propertyIds
			} else {
				this.propertyIds = this.propertyList.filter(prop => {
					if (prop.id.toString().includes(newVal)) {
						return true
					} else if (prop.property_title && prop.property_title.includes(newVal)) {
						return true
					} else if (prop.tag_project && prop.tag_project.name && prop.tag_project.name.includes(newVal)) {
						return true
					}

					return false
				}).map(prop => prop.id)
			}
		}
	},

	mounted () {
		window.scrollTo(0, 0)
		this.getAgent(this.$route.params.id).then(agent => {
			this.agent = agent
			this.loading = false

			if (agent) {
				this.getPortfolio({ agent_id: agent.id }).then(data => {
					// this.portfolioList = data.data.portfolios.map(item => ({ url: item }))
					this.portfolioList = data.data.portfolios
				})

				this.getAgentProperty(this.$route.params.id).then(propertyIds => {
					this.propertyIds = propertyIds
					this.propertyLoading = false

					this.getPropertyList(propertyIds).then(propertyList => {
						this.propertyList = propertyList
					})
				})
			}
		})
	},

	methods: {
		...mapActions({
			getAgent: 'agent/getAgent',
			getAgentProperty: 'agent/getAgentProperty',
			getPropertyList: 'property/getPropertyList',
			getPortfolio: 'page/getPortfolio'
		}),

		copyText(ref, getParams) {
			ref.className = ''
			ref.value = window.location.origin + this.$route.fullPath + (getParams ? `?${getParams}` : '')
			ref.focus()
			ref.select()

			try {
				document.execCommand('copy')
				this.snackbarText = 'คัดลอกแล้ว'
			} catch (err) {
				console.log('Oops, unable to copy')
				this.snackbarText = 'ไม่สามารถคัดลอกได้'
			} finally {
				ref.blur()
				ref.value = ''
				ref.className = 'd-none'

				this.snackbar = true
			}
		},

		viewImg (url) {
			this.view_img = url
			this.dialog = true
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.bg-light-grey {
	background-color: #e7e7e7;
}
.agent-image::v-deep {
	.v-responsive.v-image {
		@media (max-width: 959px) {
			width: 100% !important;
			height: auto !important;
		}
	}
}
.agent-detail::v-deep {
	a {
		text-decoration: none;
		color: #000;
	}
	.v-btn {
		@media (max-width: 959px) {
			width: 35% !important;
		}
	}
}
.agent-share {
	position: relative;

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100vw;
		background-color: #303030;
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		// background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, #fff 0%, #fff 50%, #ed1c24 50%, #ed1c24 100%);
		position: absolute;
		width: 16%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
</style>
